import { BrainCircuit } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export function AnalysisLoading() {
  const { t } = useLanguage();
  
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <div className="relative">
        <BrainCircuit className="w-16 h-16 text-blue-600 animate-pulse" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <div className="w-24 h-24 border-4 border-blue-600 rounded-full border-t-transparent animate-spin" />
        </div>
      </div>
      <h3 className="mt-8 text-xl font-semibold text-gray-900 text-center">
        {t('loadingTitle')}
      </h3>
      <p className="mt-2 text-gray-600 text-center max-w-sm">
        {t('loadingSubtext')}
      </p>
    </div>
  );
} 